import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '../ui/accordion';

const FAQ = () => {
  return (
    <section className="py-24 md:py-32 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Questions fréquentes</h2>
          <p className="text-lg text-gray-600">Tout ce que vous devez savoir sur les réparations</p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          <AccordionItem value="item-1" className="border rounded-lg px-6">
            <AccordionTrigger className="text-left font-semibold text-gray-900">
              Combien de temps dure une réparation ?
            </AccordionTrigger>
            <AccordionContent className="text-gray-600">
              La plupart des réparations (écran, batterie) sont réalisées le jour même, généralement en 30 minutes à 2 heures selon la complexité. Pour les réparations plus complexes, nous vous donnons un délai précis lors du diagnostic.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-2" className="border rounded-lg px-6">
            <AccordionTrigger className="text-left font-semibold text-gray-900">
              Comment connaître le prix de ma réparation ?
            </AccordionTrigger>
            <AccordionContent className="text-gray-600">
              Le devis est gratuit et immédiat : appelez-nous ou envoyez un message WhatsApp avec votre modèle et votre panne, nous vous répondons en quelques minutes. Le tarif annoncé avant la réparation est le tarif final, sans surprise.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-3" className="border rounded-lg px-6">
            <AccordionTrigger className="text-left font-semibold text-gray-900">
              Quelle est la garantie ?
            </AccordionTrigger>
            <AccordionContent className="text-gray-600">
              Toutes nos réparations sont garanties 3 mois contre tout dysfonctionnement lié à la pièce remplacée ou à l'intervention. La garantie ne couvre pas les nouveaux dommages (chute, oxydation, etc.).
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-4" className="border rounded-lg px-6">
            <AccordionTrigger className="text-left font-semibold text-gray-900">
              Dois-je prendre rendez-vous ?
            </AccordionTrigger>
            <AccordionContent className="text-gray-600">
              Oui, la prise de rendez-vous est obligatoire par téléphone. Cela me permet de confirmer la disponibilité, de préparer les pièces nécessaires et de vous garantir une intervention rapide et efficace.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-5" className="border rounded-lg px-6">
            <AccordionTrigger className="text-left font-semibold text-gray-900">
              Vous réparez aussi les Samsung ?
            </AccordionTrigger>
            <AccordionContent className="text-gray-600">
              Oui ! Nous réparons toutes les marques de smartphones : iPhone, Samsung, Huawei, Xiaomi, Oppo, etc. N'hésitez pas à nous contacter pour vérifier la disponibilité des pièces pour votre modèle.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-6" className="border rounded-lg px-6">
            <AccordionTrigger className="text-left font-semibold text-gray-900">
              Vous vous déplacez à domicile ?
            </AccordionTrigger>
            <AccordionContent className="text-gray-600">
              Oui, nous proposons un service de réparation à domicile sur Saint-Chamond et les communes environnantes. Contactez-nous pour vérifier si nous nous déplaçons dans votre zone.
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;